import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'components/ui/select';

const ContactSelectMenuList = props => (
  <components.Menu {...props}>
    {props.children}
    <div className="p-2 border-top">
      <a aria-label="new" className="clickable" onClick={props.selectProps.onCreateClick}>
        + Create new {props.selectProps.contactTypeLabel}
      </a>
    </div>
  </components.Menu>
);

ContactSelectMenuList.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.shape({
    contactTypeLabel: PropTypes.string.isRequired,
    onCreateClick: PropTypes.func.isRequired
  })
};

export default ContactSelectMenuList;
